import { pointer } from '@byecode/ui'
import styled from 'styled-components'

export const RecordSelector = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`
